import { render } from "./ClientsVideo.vue?vue&type=template&id=2d34f3e6&scoped=true"
import script from "./ClientsVideo.vue?vue&type=script&lang=js"
export * from "./ClientsVideo.vue?vue&type=script&lang=js"

import "./ClientsVideo.vue?vue&type=style&index=0&id=2d34f3e6&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d34f3e6"]])

export default __exports__